import { ADDRESSES, ETHERSCAN } from '../lib/chain';
import { short } from '../lib/format';

type Item = { name: string; address: string; stat: string };

const items: Item[] = [
  { name: 'MethaCrowdsale',     address: ADDRESSES.MethaCrowdsale,     stat: 'AUCTION ENGINE' },
  { name: 'MethaToken',         address: ADDRESSES.MethaToken,         stat: 'ERC-20 · METH' },
  { name: 'AuditingPool',       address: ADDRESSES.AuditingPool,       stat: 'MILESTONE STATE MACHINE' },
  { name: 'AuditorRegistryV2',  address: ADDRESSES.AuditorRegistryV2,  stat: 'FIRM REGISTRY · v3' },
  { name: 'OpenGovernance',     address: ADDRESSES.OpenGovernance,     stat: 'PROPOSALS + SLOTS' },
  { name: 'EternalStorage',     address: ADDRESSES.EternalStorage,     stat: 'UPGRADE PROXY' },
];

export default function ContractsStrip() {
  return (
    <div
      className="contracts"
      style={{
        // Force a single line of 6 equal columns at desktop widths. The
        // media query below collapses to 2 columns on narrow viewports so
        // the strip stays readable on phones / split-screen.
        display: 'grid',
        gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
        gap: 10,
      }}
    >
      {items.map((c) => (
        <a
          key={c.name}
          className="contract"
          href={ETHERSCAN(c.address)}
          target="_blank"
          rel="noreferrer"
          title={`Open ${c.name} on Sepolia Etherscan`}
          style={{ minWidth: 0, overflow: 'hidden' }}
        >
          <span className="name" style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.name}</span>
          <span className="addr">{short(c.address)}</span>
          <span className="stat" style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.stat}</span>
        </a>
      ))}
      <style>{`
        @media (max-width: 880px) {
          .contracts { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
        }
        @media (min-width: 881px) and (max-width: 1200px) {
          .contracts { grid-template-columns: repeat(3, minmax(0, 1fr)) !important; }
        }
      `}</style>
    </div>
  );
}
